import React from "react";
import styled from "@emotion/styled";
import NoChartData from "../../img/token_selector/no_data_chart.svg?react";
import { Text } from "../general/Text";
import { css } from "@emotion/react";
import { Address } from "viem";
import { useCandleStickChart } from "../../hooks/useCandleStickChart";

interface CandleStickChartProps {
  data: Array<Array<number>>;
  isLoading?: boolean;
  isError?: boolean;
  id: Address;
  height: number;
}

export const CandleStickChart = ({
  data,
  isLoading,
  isError,
  id,
  height,
}: CandleStickChartProps) => {
  useCandleStickChart(data, id);
  if (isError || isLoading) {
    return <NoChartDataContainer />;
  }

  return <div id={id} style={{ height: `${height}px`, width: "100%" }} />;
};

const NoChartDataContainer = () => {
  return (
    <Container>
      <NoChartData />
      <Text
        textCss={css`
          position: absolute;
          top: 50%;
        `}
        textStyle={"Title"}
        size={"XXS"}
      >
        Data Unavailable
      </Text>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
